<template>
  <div class="sales-reports-send-to-email-button">
    <SalesReportSendToEmailModal
      v-model="isSendToEmailModalOpen"
      :title="title"
      @sendToEmail="sendToEmail"
    />

    <ElButton
      :loading="loading"
      type="primary"
      @click="openModal('isSendToEmailModalOpen')"
    >
      <i class="material-icons">
        email
      </i>
      <span>{{ title }}</span>
    </ElButton>
  </div>
</template>

<script>
import modal from '@/mixins/modal';

import SalesReportSendToEmailModal from './SalesReportSendToEmailModal';

export default {
  name: 'SalesReportsSendToEmailButton',

  components: {
    SalesReportSendToEmailModal,
  },

  mixins: [modal],

  props: {
    title: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isSendToEmailModalOpen: false,
    };
  },

  methods: {
    sendToEmail(email) {
      this.$emit('sendToEmail', email);
    },
  },
};
</script>

<style lang="scss">
.sales-reports-send-to-email-button {
  display: inline-block;
}
</style>
